// Communication — Détail Appels (aujourd'hui, semaine, total, taux réponse).
import { useEffect, useState } from "react";
import { Phone, PhoneIncoming, PhoneMissed, Clock, TrendingUp, Loader2 } from "lucide-react";
import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL;
const auth = () => {
  const t = localStorage.getItem("session_token");
  return t ? { Authorization: `Bearer ${t}` } : {};
};

function MiniStat({ icon: Icon, label, value, color }) {
  return (
    <div className="flex items-center gap-3 p-3 rounded-lg"
      style={{ background: "var(--oh-bg-surface)" }}>
      <div className="w-9 h-9 rounded-lg flex items-center justify-center"
        style={{ backgroundColor: `${color}20`, color }}>
        <Icon className="w-4 h-4" />
      </div>
      <div>
        <p className="text-xs" style={{ color: "var(--oh-text-muted)" }}>{label}</p>
        <p className="text-lg font-bold" style={{ color: "var(--oh-text)" }}>{value}</p>
      </div>
    </div>
  );
}

export default function CommunicationAppelsWidget() {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const r = await axios.get(`${API}/api/calls?limit=100`, { headers: auth() });
        const calls = r.data.calls || [];
        const today = new Date().toDateString();
        const thisWeek = new Date(); thisWeek.setDate(thisWeek.getDate() - 7);
        const todayN = calls.filter(c => new Date(c.start_time).toDateString() === today).length;
        const weekN = calls.filter(c => new Date(c.start_time) >= thisWeek).length;
        const completed = calls.filter(c => c.status === "completed").length;
        const missed = calls.filter(c => c.status === "no-answer").length;
        if (!cancelled) setStats({ total: calls.length, today: todayN, week: weekN, completed, missed,
          taux: calls.length > 0 ? Math.round((completed / calls.length) * 100) : 0 });
      } finally { if (!cancelled) setLoading(false); }
    })();
    return () => { cancelled = true; };
  }, []);

  if (loading) return <div className="rounded-xl p-5 flex items-center justify-center"
    style={{ background: "var(--oh-bg-elevated)", border: "1px solid var(--oh-border)" }}>
    <Loader2 className="w-5 h-5 animate-spin" style={{ color: "var(--oh-text-muted)" }} /></div>;

  return (
    <div className="rounded-xl p-5" style={{ background: "var(--oh-bg-elevated)", border: "1px solid var(--oh-border)" }}
      data-testid="communication-appels-widget">
      <h3 className="font-semibold mb-4 flex items-center gap-2" style={{ color: "var(--oh-text)" }}>
        <Phone className="w-4 h-4" style={{ color: "var(--oh-stat-blue-text)" }} />
        Appels
      </h3>
      <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
        <MiniStat icon={Clock} label="Aujourd'hui" value={stats.today} color="var(--oh-stat-blue-text)" />
        <MiniStat icon={Phone} label="Cette semaine" value={stats.week} color="#8b5cf6" />
        <MiniStat icon={PhoneIncoming} label="Complétés" value={stats.completed} color="var(--oh-stat-green-text)" />
        <MiniStat icon={PhoneMissed} label="Manqués" value={stats.missed} color="var(--oh-stat-red-text)" />
        <MiniStat icon={TrendingUp} label="Taux réponse" value={`${stats.taux}%`} color="var(--oh-stat-amber-text)" />
      </div>
    </div>
  );
}
